import React from 'react'

function IconArrowRight() {
  return <svg className="icon icon--arrow-right">
    <use xlinkHref="#icon-arrow-right" />
  </svg>
}

export default IconArrowRight
